import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import CONSTANTS from '../../_constants/constants';

import { SharedModule } from '../../_shared/shared.module';
import { AlertService } from '../../_shared/services/alert.service';
import { UtilService } from '../../_shared/services/util.service';

import { atLeastOneCheckboxCheckedValidator } from '../../_shared/validators/atLeastOneCheckboxCheckedValidator';

import { Facility } from '../shared/facility.model';
import { FacilityModalService } from '../shared/facility-modal.service';
import { FacilityService } from '../shared/facility.service';

@Component({
  selector: 'app-facility-detail',
  templateUrl: './facility-detail.component.html',
  standalone: true,
  imports: [SharedModule],
})
export class FacilityDetailComponent implements OnInit {
  constructor(
    private facilityService: FacilityService,
    private facilityModalService: FacilityModalService,
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private utilService: UtilService
  ) {}

  @Input() facility: Facility;
  @Input() mode: string;
  @Input() defaultLanguage;
  @Input() additionalLanguages;
  @Input() isModal = false;

  @Output() private savedFacility = new EventEmitter<Facility>();
  @Output() private canceledFacility = new EventEmitter();

  form: FormGroup;

  formSubmited = false;

  createMode = false;
  editMode = false;
  viewMode = false;

  productTypes = CONSTANTS.ALL_PRODUCT_TYPES;

  allProductTypesChecked = false;

  serverErrors = [];
  sendingForm = false;

  // private facilityCopy;

  ngOnInit() {
    this.setFacilityForm();

    if (this.facility.id) {
      this.setItemOptions(this.facility, this.mode);
    } else {
      this.createMode = true;

      // In case we don't initialize the object in the parent component - to work with setProductTypesChecked
      if (!this.facility.type) {
        this.facility.type = {};
      }
    }

    this.setProductTypesChecked();
  }

  // Try to replace this, avoid get as possible
  get productTypesFormArray() {
    return this.form.controls['type'] as FormArray;
  }

  checkAllProductTypes(event) {
    this.allProductTypesChecked = event.target.checked; // checked

    this.productTypesFormArray.controls.forEach((x) => {
      x.setValue(event.target.checked);
    });
  }

  checkProductType(event) {
    if (!event.target.checked) {
      this.allProductTypesChecked = false;
    }
  }

  // Referenced from app-translation-options
  onOpenedTranslation(language) {
    this.facilityModalService.openFacilityTranslation(this.facility, language);
  }

  // Referenced from app-item-detail-form-actions
  onSavedFacility() {
    this.formSubmited = true;

    if (this.form.invalid) {
      this.serverErrors = [];

      return;
    }

    const fields = ['name', 'description'];
    const formData = this.utilService.deleteNullFields(fields, this.form.value);

    formData.type = this.utilService.productTypesFormArrayChecked(
      this.productTypes,
      this.productTypesFormArray
    );

    this.sendingForm = true;

    this.facilityService
      .saveFacility(this.facility.id, formData, this.defaultLanguage.lang)
      .subscribe({
        next: (response) => {
          let msg = '';

          if (this.editMode) {
            msg = 'MODIFIED_FACILITY';

            // needed if we want to keep the page opened or if used in page
            this.facility = response;
            this.setItemOptions(response);
          } else {
            msg = 'NEW_ADDED_FACILITY';
            // this.facility = response; // reload item - needed ?
          }

          this.alertService.open(msg);

          // this.setItemOptions(response);

          this.sendingForm = false;

          this.savedFacility.emit(response);
        },
        error: (response) => {
          this.serverErrors = this.utilService.setFormServerErrors(response.error.errors);

          this.sendingForm = false;
        },
      });
  }

  // Referenced from app-item-detail-form-actions
  onCanceled() {
    // if (this.editMode) {
    //   this.cancelEdit();
    //   return;
    // }

    this.canceledFacility.emit();
  }

  // Referenced from app-item-detail-form-actions
  onEditedFacility() {
    this.editMode = true;
    this.viewMode = false;

    this.enableDisableProductTypes('enable');
  }

  // private cancelEdit() {
  //   this.facility = this.facilityCopy;
  //   this.setItemOptions(this.facility);
  // }

  private setItemOptions(facility, mode = '') {
    this.createMode = false;
    this.editMode = false;
    this.viewMode = true;

    if (mode === 'edit') {
      this.onEditedFacility();
    }

    // this.facilityCopy = JSON.parse(JSON.stringify(facility));
  }

  private setFacilityForm() {
    this.form = this.formBuilder.group({
      name: [
        this.facility.name,
        {
          validators: [
            Validators.required,
            // Validators.maxLength(100), used it in html to limit the input length
            // Validators.pattern(this.utilService.selectInputPattern('text')),
          ],
          updateOn: 'blur',
        },
      ],
      description: [this.facility.description],
      type: new FormArray([], atLeastOneCheckboxCheckedValidator(1)),
    });
  }

  private setProductTypesChecked() {
    for (let productType of this.productTypes) {
      let isSelected = Object.keys(this.facility.type).some((x) => x === productType.type);

      this.productTypesFormArray.push(new FormControl(isSelected));
    }

    const option = this.viewMode ? 'disable' : 'enable';

    this.enableDisableProductTypes(option);
  }

  private enableDisableProductTypes(option) {
    this.productTypesFormArray.controls.forEach((x) => {
      if (option === 'enable') {
        x.enable();
      } else {
        x.disable();
      }
    });
  }
}
